import DocumentTitle from 'react-document-title';

import FiltersApp from 'hb-react/frontoffice/apps/Filters/startup/FiltersAppClient';
import { useDefaultAppContexts } from 'hb-react/frontoffice/contexts/withDefaultAppContexts';
import { generatePageTitle } from 'hb-react/shared/utils/generatePageTitle';
import { getPageTitleFromNetwork } from 'hb-react/shared/utils/getPageTitleFromNetwork';

import TopicsLists from '../components/TopicsLists';
import TopicsIndexProvider from '../contexts/TopicsIndexContext';
import useTopicsIndexApp from '../hooks/useTopicsIndexApp';
import useUserAuthorizationInfo from '../hooks/useUserAuthorizationInfo';
import isAuthorizedUser from '../utils/isAuthorizedUser';

const TopicsIndexApp = ({ pageTitle }) => {
  const {
    areFetchedAllCategories,
    areUsingFilters,
    currentView,
    displaySuccessMessageJoinPublicTopic,
    fetchCategoryTopics,
    fetchMyTopics,
    fetchOtherTopics,
    fetchFilteredTopics,
    fetchSuggestedTopics,
    filters,
    filtersAppConfig,
    filtersAppRef,
    handleResetFilters,
    isConnectedUser,
    isEnabledToPublishSuperCategories,
    itemsPerRow,
    pushHandleFetchCategoryTopics,
    selectedCategory,
    selectedCategoryId,
    selectedSuperCategory,
    selectedSuperCategoryId,
    setAreFetchedAllCategories,
    setCategoriesView,
    setCategoryView,
    setCurrentView,
    setDisplaySuccessMessageJoinPublicTopic,
    setHandleFetchMyTopics,
    setHandleFetchOtherTopics,
    setHandleFetchFilteredTopics,
    setHandleFetchSuggestedTopics,
    setMyTopicsView,
    setSelectedCategory,
    setSelectedCategoryId,
    setSelectedSuperCategory,
    setSelectedSuperCategoryId,
    setSuggestedTopicsView,
    setSuperCategoryView,
    setTotalAllCategories,
    setTotalAllTopics,
    totalAllCategories,
    totalAllTopics,
  } = useTopicsIndexApp();
  const { setUserAuthorizationInfo, userAuthorizationInfo } =
    useUserAuthorizationInfo();
  const { currentNetwork } = useDefaultAppContexts();

  return (
    <>
      <DocumentTitle
        title={generatePageTitle({
          networkName: getPageTitleFromNetwork(currentNetwork),
          title: pageTitle,
        })}
      />
      <TopicsIndexProvider
        areFetchedAllCategories={areFetchedAllCategories}
        areUsingFilters={areUsingFilters}
        currentView={currentView}
        displaySuccessMessageJoinPublicTopic={
          displaySuccessMessageJoinPublicTopic
        }
        fetchCategoryTopics={fetchCategoryTopics}
        fetchMyTopics={fetchMyTopics}
        fetchOtherTopics={fetchOtherTopics}
        fetchFilteredTopics={fetchFilteredTopics}
        fetchSuggestedTopics={fetchSuggestedTopics}
        filters={filters}
        isConnectedUser={isConnectedUser}
        isEnabledToPublishSuperCategories={isEnabledToPublishSuperCategories}
        itemsPerRow={itemsPerRow}
        pushHandleFetchCategoryTopics={pushHandleFetchCategoryTopics}
        resetFilters={handleResetFilters}
        selectedCategory={selectedCategory}
        selectedCategoryId={selectedCategoryId}
        selectedSuperCategory={selectedSuperCategory}
        selectedSuperCategoryId={selectedSuperCategoryId}
        setAreFetchedAllCategories={setAreFetchedAllCategories}
        setCategoriesView={setCategoriesView}
        setCategoryView={setCategoryView}
        setCurrentView={setCurrentView}
        setDisplaySuccessMessageJoinPublicTopic={
          setDisplaySuccessMessageJoinPublicTopic
        }
        setHandleFetchMyTopics={setHandleFetchMyTopics}
        setHandleFetchOtherTopics={setHandleFetchOtherTopics}
        setHandleFetchFilteredTopics={setHandleFetchFilteredTopics}
        setHandleFetchSuggestedTopics={setHandleFetchSuggestedTopics}
        setMyTopicsView={setMyTopicsView}
        setSelectedCategory={setSelectedCategory}
        setSelectedCategoryId={setSelectedCategoryId}
        setSelectedSuperCategory={setSelectedSuperCategory}
        setSelectedSuperCategoryId={setSelectedSuperCategoryId}
        setSuggestedTopicsView={setSuggestedTopicsView}
        setSuperCategoryView={setSuperCategoryView}
        setTotalAllCategories={setTotalAllCategories}
        setTotalAllTopics={setTotalAllTopics}
        setUserAuthorizationInfo={setUserAuthorizationInfo}
        totalAllCategories={totalAllCategories}
        totalAllTopics={totalAllTopics}
        userAuthorizationInfo={userAuthorizationInfo}
      >
        {isAuthorizedUser(userAuthorizationInfo.isAuthorized) && (
          <FiltersApp config={filtersAppConfig} ref={filtersAppRef} />
        )}

        <TopicsLists />
      </TopicsIndexProvider>
    </>
  );
};

export default TopicsIndexApp;
